// カラーソート**固有**の設定（localStorage 永続）。
//
// ポータル横断の設定（音量・ミュート・BGM・言語）は
// [platform/net/settings.ts](@/platform/net/settings) が持つ。ここにあるのは
// 「このゲームでしか意味を持たない」項目だけ。所属の決め方は CLAUDE.md の
// 「設定は所属で2つに分かれる」を参照。
//
// キーは `colorsort.*`（＝`game_key` と同じ文字列）。データ削除が接頭辞で掃くので、
// ここに増やしたぶんは自動で消える対象になる。
import type { GameSettingsSlice } from '@/platform/net/settings';
import { GAME_KEY } from '../gameKey';

const K_MARKS = `${GAME_KEY}.marksOn`;

export const GAME_SETTINGS_DEFAULTS = {
  /** 液に色ごとの印を重ねる。 */
  marksOn: true,
} as const;

/**
 * 色の印（既定 ON）。
 *
 * 🔴 **既定を ON にするのは親切のためではない**。このゲームは最大12色を使う。
 *   ⚠️ 見分けられない人には**「解けない盤」に見える**——しかも本人にも
 *   「色が分からない」のか「難しい」のかの区別がつかないので、
 *   **設定を探しに行く理由すら生まれない**。⇒ 消せるようにはするが、**既定では出す**。
 */
export function isMarksOn(): boolean {
  const v = localStorage.getItem(K_MARKS);
  return v === null ? GAME_SETTINGS_DEFAULTS.marksOn : v === '1';
}

export function setMarksOn(on: boolean): void {
  localStorage.setItem(K_MARKS, on ? '1' : '0');
}

/** このゲームの設定を既定値へ戻す。 */
export function resetGameSettings(): void {
  setMarksOn(GAME_SETTINGS_DEFAULTS.marksOn);
}

/**
 * サーバー同期用のスライス。`registry.ts` に載せると
 * `/api/settings` の `games.<gameKey>` として自動で往復するようになる。
 */
export const colorsortSettingsSlice: GameSettingsSlice = {
  gameKey: GAME_KEY,
  read: () => ({ marksOn: isMarksOn() }),
  apply: (s) => {
    if (typeof s.marksOn === 'boolean') setMarksOn(s.marksOn);
  },
  reset: resetGameSettings,
};
